import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'night-950' | 'night-900' | 'night-800' | 'night-700';
}
export function Section({
  children,
  className = '',
  id,
  background = 'night-950'
}: SectionProps) {
  const bgColors = {
    'night-950': 'bg-night-950',
    'night-900': 'bg-night-900',
    'night-800': 'bg-night-800',
    'night-700': 'bg-night-700'
  };
  return <section id={id} className={`w-full py-10 md:py-16 ${bgColors[background]} ${className}`} data-id="element-191">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto px-6" data-id="element-192">
        {children}
      </motion.div>
    </section>;
}